import { render, staticRenderFns } from "./AiAssistant.vue?vue&type=template&id=081be116&scoped=true&"
import script from "./AiAssistant.vue?vue&type=script&lang=js&"
export * from "./AiAssistant.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistant.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AiAssistant.vue?vue&type=style&index=1&id=081be116&lang=scss&scoped=true&"
import style2 from "./AiAssistant.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081be116",
  null
  
)

export default component.exports